import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'round' })
export class RoundPipe implements PipeTransform {
  transform(value: any, options = {}): any {
    if (value == null) {
      return 'n/a'
    }

    const opts = Object.merge({
      precision: 2
    }, options)

    const num_value = Number(value)
    if (num_value === 0) {
      return 0
    } else if (isNaN(num_value)){
      return value
    }

    const precision = opts['precision']
    const pow = (precision) - Math.floor(Math.log(Math.abs(num_value)) / Math.LN10) - 1

    const mult = pow < 0
      ? 1 / Math.pow(10, Math.abs(pow))
      : Math.pow(10, pow)

    let num = Math.round(num_value * mult) / mult
    if (num > Math.pow(10, precision)) {
      num = Math.round(num)
    }
    return num
  }
}
